// extracted by mini-css-extract-plugin
module.exports = {"container":"LandingPageHeader_container__9SEnr","background":"LandingPageHeader_background__xhSbF"};